import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthQuery } from 'app/core/auth/auth.query';
import { guid } from 'app/shared/utils';
import { ReplaySubject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { WS_ENDPOINT } from './backend.config';
import { WebSocketConnection, WebSocketMessage } from './web-socket-message.model';
import { webSocketMessage } from './web-socket.actions';


@Injectable({
    providedIn: 'root',
})
export class WebSocketService {

    private socket: Socket;

    private roomsConnected: Set<string> = new Set();

    private readonly uid: string;

    private _connection = new ReplaySubject<WebSocketConnection>(1);

    get connection() {
        return this._connection.asObservable();
    }

    constructor(@Inject(WS_ENDPOINT) endpoint: string, private store: Store, private authQuery: AuthQuery) {
        this.uid = `/${guid()}`;
        this.authQuery
            .withAuthToken$()
            .subscribe(token => {
                this.socket = io(endpoint, {
                    withCredentials: true,
                    reconnection: true,
                    reconnectionDelay: 5000, // Affected by +/- randomizationFactor = 0.5 => 2500 - 7500
                    reconnectionDelayMax: 10000,
                    reconnectionAttempts: Infinity,
                    auth: {
                        token: token
                    }
                });

                this.socket.on('connect', () => {
                    console.log('connected to socket', this.socket.id);
                    this.joinRoom(this.uid);
                });

                this.socket.on('room-subscribed', () => {
                    this._connection.next({
                        clientId: this.uid,
                    });
                });

                this.socket.on('disconnect', () => {
                    console.log(`disconnected from socket`);
                });

                this.socket.on('error', (error: any) => {
                    console.log('error on socket', error);
                    this._connection.error(error);
                });

                this.socket.on('notify', (message: WebSocketMessage) => {
                    this.store.dispatch(webSocketMessage({ message }));
                });

                this.socket.on('reconnect', () => {
                    this.roomsConnected.forEach(name => this.joinRoom(name));
                });
            });
    }

    joinRoom(name: string) {
        this.roomsConnected.add(name);
        this.socket.emit('subscribe', name);
    }

    leaveRoom(name: string) {
        this.socket.emit('unsubscribe', name);
        this.roomsConnected.delete(name);
    }
}
